var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.226473 8.6205C-0.0734506 8.92042 -0.0795714 9.45294 0.232593 9.76511C0.550879 10.0773 1.0834 10.0712 1.3772 9.77735L5.00076 6.15379L8.6182 9.77123C8.92424 10.0773 9.45064 10.0773 9.7628 9.76511C10.075 9.44682 10.075 8.92655 9.76893 8.6205L6.15148 5.00306L9.76893 1.3795C10.075 1.07346 10.0811 0.547059 9.7628 0.234894C9.45064 -0.0772704 8.92424 -0.0772704 8.6182 0.228774L5.00076 3.84621L1.3772 0.228774C1.0834 -0.0711496 0.544758 -0.0833913 0.232593 0.234894C-0.0795714 0.547059 -0.0734506 1.0857 0.226473 1.3795L3.84391 5.00306L0.226473 8.6205Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1053507de78f0c5a6b791ce6eefeb4b6.svg";
export { ForwardRef as ReactComponent };